export const SEARCH_GAMES_QUERY = `
query SearchGames($searchTerm: String!, $site: String!, $countryCode: String, $menuItem: String, $first: Int, $offset: Int) {
casinoGameInventory {
    searchGames(
      searchTerm: $searchTerm
      site: $site
      countryCode: $countryCode
      menuItem: $menuItem
      first: $first
      offset: $offset
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      results {
        ... on CasinoGameInventoryGame {
          __typename
          id
          name
          href
          thumbUrl
          thumbUrlTab
          thumbUrlMob
          provider { id name handle }
          category { id name }
	  menuItem(section: 1) { handle name }
          isNew
          isFeatured
          rating
          minBet(currency: "USD")
          maxBet(currency: "USD")
        }
        ... on CasinoGameInventoryProviderGroup {
          __typename
          games { id name handle thumbUrl }
        }
      }
    }
  }
}
`;
